<template>
    <div class="public_container payable_details_wrap" v-loading="loading">
        <div class="returnNavBar">
            <ReturnNavBar title="返回" :isTitleNormal="true" :isAllFunctions="true"> </ReturnNavBar>
        </div>
        <div class="mobile_container">
            <div class="form_module_title">基本信息</div>
            <div class="form_module_content">
                <!-- <p>应收编号：{{ receivable_no }}</p> -->
                <template v-if="receivableDetails.source_type == 'order'">
                    <p>
                        关联订单：<span class="link-label">{{ receivableDetails.basic_info.order_no }}</span>
                    </p>
                    <div class="mobile_detail_head_user_wrap">
                        客户联系人：
                        <!-- <div
                            class="mobile_detail_head_user"
                            v-if="receivableDetails.basic_info && receivableDetails.basic_info.contact_id"
                            @click="handleClickUserInfo({ id: receivableDetails.basic_info.contact_id })"
                        >
                            <img
                                :src="
                                    receivableDetails.basic_info.contact_avatar
                                        ? receivableDetails.basic_info.contact_avatar
                                        : defaultImg
                                "
                                alt=""
                            />
                            <span class="ellipsis">{{ receivableDetails.basic_info.contact_name }}</span>
                        </div> -->
                        <span>{{
                            receivableDetails.basic_info.customer_contact_info &&
                            receivableDetails.basic_info.customer_contact_info.name
                        }}</span>
                    </div>
                    <p>
                        订单总金额：{{
                            Number(receivableDetails.basic_info.order_amount).toLocaleString(undefined, {
                                minimumFractionDigits: 2,
                                maximumFractionDigits: 2,
                            })
                        }}
                    </p>
                    <div class="mobile_detail_head_user_wrap">
                        销售：
                        <div
                            class="mobile_detail_head_user"
                            v-if="receivableDetails.basic_info && receivableDetails.basic_info.salesperson_info"
                            @click="handleClickUserInfo(receivableDetails.basic_info.salesperson_info)"
                        >
                            <img
                                :src="
                                    receivableDetails.basic_info.salesperson_info &&
                                    receivableDetails.basic_info.salesperson_info.avatar
                                        ? receivableDetails.basic_info.salesperson_info.avatar
                                        : defaultImg
                                "
                                alt=""
                            />
                            <span class="ellipsis">{{
                                receivableDetails.basic_info.salesperson_info &&
                                receivableDetails.basic_info.salesperson_info.name
                            }}</span>
                        </div>
                    </div>
                </template>
                <template v-else-if="receivableDetails.source_type == 'purchase_refund'">
                    <p>应收编号：{{ receivable_no }}</p>
                    <p>供应商名称：{{ receivableDetails.basic_info.supplier_name }}</p>
                    <p>
                        采购编号：<span
                            class="link-label"
                            @click="handleClickRelateId(receivableDetails.basic_info.purchase_id)"
                            >{{ receivableDetails.basic_info.purchase_refund_no }}</span
                        >
                    </p>
                    <p>
                        审批编号：<span class="link-label">{{ receivableDetails.basic_info.approval_id }}</span>
                    </p>
                    <div class="mobile_detail_head_user_wrap">
                        申请人：
                        <div
                            class="mobile_detail_head_user"
                            v-if="receivableDetails.basic_info && receivableDetails.basic_info.uid_info"
                            @click="handleClickUserInfo(receivableDetails.basic_info.uid_info)"
                        >
                            <img
                                :src="
                                    receivableDetails.basic_info.uid_info &&
                                    receivableDetails.basic_info.uid_info.avatar
                                        ? receivableDetails.basic_info.uid_info.avatar
                                        : defaultImg
                                "
                                alt=""
                            />
                            <span class="ellipsis">{{
                                receivableDetails.basic_info.uid_info && receivableDetails.basic_info.uid_info.name
                            }}</span>
                        </div>
                    </div>
                    <p>申请时间：{{ receivableDetails.basic_info.apply_time }}</p>
                </template>
            </div>
            <template v-if="receivableDetails.source_type == 'order'">
                <div class="form_module_title">回款信息</div>
                <div class="form_module_content">
                    <p>回款公司：{{ receivableDetails.basic_info.payment_company_name }}</p>
                    <p>回款日期：{{ receivableDetails.basic_info.payment_date }}</p>
                    <p>回款方式：{{ receivableDetails.basic_info.payment_method_name }}</p>
                    <p>
                        本次回款金额：{{
                            Number(receivableDetails.basic_info.payment_amount).toLocaleString(undefined, {
                                minimumFractionDigits: 2,
                                maximumFractionDigits: 2,
                            })
                        }}
                    </p>
                    <p>备注：<br />{{ receivableDetails.basic_info.remark || '--'}}</p>
                    <div>
                        附件：<br />
                        <ul
                            class="voucher_list"
                            v-if="
                                receivableDetails.basic_info.attachments &&
                                receivableDetails.basic_info.attachments.length
                            "
                        >
                            <li
                                :key="index"
                                class="voucher_item"
                                v-for="(item, index) in receivableDetails.basic_info.attachments"
                                @click="handleClickPreviewImg(index, receivableDetails.basic_info.attachments)"
                            >
                                <van-image :src="item" alt=""> </van-image>
                            </li>
                        </ul>
                        <template v-else>
                            --
                        </template>
                    </div>
                </div>
            </template>
        </div>
        <userDetailDialog
            v-if="userDetailPopupShow"
            :userDetailPopupShow.sync="userDetailPopupShow"
            :userId="userDetailId"
        />
    </div>
</template>
<script>
import { ReceivableDetail } from "@/api";
import { ImagePreview } from "vant";
import ReturnNavBar from "@/components/mComponents/ReturnNavBar.vue";
import userDetailDialog from "@/components/mComponents/userDetailDialog";
export default {
    name: "RepaymentDetails",
    components: { ReturnNavBar, userDetailDialog },
    data() {
        return {
            receivable_no: "",
            loading: false,
            defaultImg: require("@/assets/images/default.jpg"),
            receivableDetails: {
                source_type: "",
                basic_info: {}, // 订单信息
                receivable_info: {}, // 财务信息
                other_info: {}, // 驳回信息 或 作废信息
            },
            payTypeList: [
                { name: "电汇", value: 1 },
                { name: "微信", value: 2 },
                { name: "支付宝", value: 3 },
                { name: "现金", value: 4 },
                { name: "银行承兑", value: 5 },
                { name: "商业承兑", value: 6 },
                { name: "支票", value: 7 },
            ],
            // 人员详细信息
            userDetailPopupShow: false,
            userDetailId: "",
        };
    },
    activated() {
        if (this.$route.query) {
            this.receivable_no = this.$route.query.receivable_no;
            if (this.receivable_no) {
                this.getReceivableDetail();
            }
        }
    },
    created() {
        if (this.$route.query) {
            this.receivable_no = this.$route.query.receivable_no;
            if (this.receivable_no) {
                this.getReceivableDetail();
            }
        }
    },
    methods: {
        // 应收详情
        getReceivableDetail() {
            ReceivableDetail({ receivable_no: this.receivable_no }).then((res) => {
                if (res.code === 200) {
                    const data = res.data || {};
                    this.receivableDetails = data;
                }
            });
        },
        // 人员详细信息
        handleClickUserInfo(info) {
            this.userDetailId = info.id;
            this.userDetailPopupShow = true;
        },
        // 图片预览
        handleClickPreviewImg(index, images) {
            ImagePreview({
                images,
                startPosition: index,
            });
        },
        // 采购详情
        handleClickRelateId(purchaseId) {
            this.$router.push({
                name: "purchase_detail",
                query: {
                    purchase_id: purchaseId,
                },
            });
        },
        //查看订单详情
        handleClickOrderDetail() {
            this.$router.push({
                name: "OrderDetail",
                // params: {
                //     isPush: true,
                // },
                query: {
                    order_id: this.receivableDetails.basic_info.order_no,
                    name: this.receivableDetails.basic_info.order_no,
                    query_type: "order_no",
                },
            });
        },
    },
};
</script>
<style lang="scss" scoped>
.ml_10 {
    margin-left: 10px;
}

.payable_details_wrap {
    background: rgba(255, 255, 255, 1);

    .mobile_container {
        background: rgba(255, 255, 255, 1);

        .form_module_title {
            font-weight: 700;
            font-size: 14px;
            line-height: 24px;
            color: #333333;
            padding: 10px 16px 10px 28px;
            position: relative;

            &::before {
                content: "";
                width: 4px;
                height: 22px;
                opacity: 1;
                border-radius: 20px;
                background: #2990ff;
                position: absolute;
                left: 16px;
            }
        }

        .form_module_content {
            padding: 0 16px;

            & > p,
            & > div {
                font-size: 14px;
                font-weight: 400;
                letter-spacing: 0px;
                line-height: 22px;
                color: rgba(102, 102, 102, 1);
                margin-bottom: 8px;
            }
        }

        ul {
            padding: 0 16px;

            li {
                border-radius: 6px;
                background: rgba(249, 249, 249, 1);
                padding: 8px 10px 2px;
                margin-bottom: 8px;

                & > p,
                & > div {
                    font-size: 14px;
                    font-weight: 400;
                    letter-spacing: 0px;
                    line-height: 22px;
                    color: rgba(102, 102, 102, 1);
                    margin-bottom: 8px;
                }
            }

            .form_module_content {
                padding: 0;
            }
        }

        .voucher_list {
            margin-top: 10px;
            padding: 0;
            display: flex;
            gap: 8px;

            .voucher_item {
                width: 44px;
                height: 44px;
                cursor: pointer;
                position: relative;
                text-align: center;
                line-height: 44px;
                border-radius: 4px;

                .van-image {
                    max-width: 100%;
                    max-height: 100%;
                }

                img {
                    max-width: 100%;
                    max-height: 100%;
                    object-fit: cover;
                }

                .icon-guanbi_dise {
                    position: absolute;
                    right: -8px;
                    top: -8px;
                    cursor: pointer;
                    font-size: 16px;
                    color: rgba(191, 191, 191, 1);
                    line-height: 16px;
                }
            }
        }
    }
}
</style>
<style lang="scss">
.van-image-preview__overlay {
    background: rgba(0, 0, 0, 0.3);
}

.van-image-preview {
    .van-image-preview__index {
        top: auto;
        bottom: 26px !important;
        text-shadow: none;
    }
}
</style>
